// extracted by mini-css-extract-plugin
export default {"component":"b1KXhQ","headline":"c1KXhQ","linkList":"d1KXhQ","linkListItem":"e1KXhQ","link":"f1KXhQ","make":"g1KXhQ"};